/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EnumVisitorMaterialableTrackEventFromJSON, EnumVisitorMaterialableTrackEventToJSON } from './EnumVisitorMaterialableTrackEvent';
export function VisitorMaterialableTrackFromJSON(json) {
    return VisitorMaterialableTrackFromJSONTyped(json, false);
}
export function VisitorMaterialableTrackFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        event: !exists(json, 'event') ? undefined : EnumVisitorMaterialableTrackEventFromJSON(json['event']),
        elapsedSecond: !exists(json, 'elapsed_second') ? undefined : json['elapsed_second'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at']
    };
}
export function VisitorMaterialableTrackToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        event: EnumVisitorMaterialableTrackEventToJSON(value.event),
        elapsed_second: value.elapsedSecond,
        created_at: value.createdAt,
        updated_at: value.updatedAt
    };
}
